import { Outlet } from 'react-router-dom';
import { NotificationCenter } from '@/app/layout/NotificationCenter';
import { Sidebar } from '@/app/layout/Sidebar';

/**
 * The signed-in shell: a fixed left rail beside a cream content card.
 *
 * Replaces the old sticky top header. Route-level composition means the shell no
 * longer has to ask `location.pathname === '/login'` to decide whether to render
 * itself — /login sits under AuthLayout instead.
 *
 * The rail sizes itself — `flex: none` and its own width in shell.css — so this
 * layout never states a number and the shell does not have to know that the rail
 * has two widths, animates between them, and floats its expanded panel over the
 * content rather than pushing it.
 */
export function AppLayout() {
  return (
    <div className="shell">
      <Sidebar />
      <main className="shell__content">
        <Outlet />
      </main>
      <NotificationCenter />
    </div>
  );
}
